<template>
  <div class="profile-section">
    <profile-section-header
      title="Business Information"
      @handle-edit-click="handleEditClick"
      :isEditing="isEditing"
    />
    <ProfileSubSectionHeader title="Description" icon="description-icon" />
    <p
      v-if="profile.description"
      v-html="profile.description"
      class="company-desc"
    ></p>

    <div
      class="company-profile-photos"
      v-if="profile.showcasePhotos && profile.showcasePhotos.length"
    >
      <Carousel
        :class="{ 'left-aligned-carousel': !showNavigation }"
        :items-to-show="itemsToShow"
        :wrap-around="false"
        :mouse-drag="showNavigation"
        :snap-align="showNavigation ? 'start' : 'center'"
      >
        <Slide v-for="(photo, idx) in showcasePhotos" :key="idx">
          <signed-image :file="photo" alt="" type="small" :clickable="true" />
        </Slide>
        <template #addons v-if="showNavigation">
          <Navigation />
        </template>
      </Carousel>
      <p class="images-count">
        {{ profile.showcasePhotos.length }} images total
      </p>
    </div>

    <ProfileSubSectionHeader
      title="Service Trade Categories"
      icon="trade-experience-icon"
    />
    <capsule-list
      v-if="
        profile.provider &&
        (profile.provider.isVendor
          ? profile.tradesRelatedToProduct?.length
          : profile.selfPerformWorkCategories?.length)
      "
      :items="
        profile.provider.isVendor
          ? profile.tradesRelatedToProduct
          : profile.selfPerformWorkCategories
      "
      :highlighted="true"
    />
    <template v-else-if="profile.provider">Not specified</template>
    <template v-else>Not specified</template>

    <ProfileSubSectionHeader
      title="Operational Details"
      icon="operational-details-icon"
    />
    <OperationalDetails
      :profile="profile"
      :jobseekerCompanyView="jobseekerCompanyView"
    />

    <div v-if="profile.provider || profile.vendor">
      <ProfileSubSectionHeader
        title="Industry Organizations & Affiliations"
        icon="affiliations"
      />
      <capsule-list
        v-if="profile.affiliations.length"
        :items="profile.affiliations.map((affiliation) => affiliation.name)"
        :highlighted="true"
      />
      <template v-else>Not specified</template>

      <ProfileSubSectionHeader
        title="Diverse Business Designations"
        icon="qualified-designation"
      />
      <capsule-list
        v-if="profile.qualifiedDesignations.length"
        :items="profile.qualifiedDesignations"
        :highlighted="true"
      />
      <template v-else>Not specified</template>
    </div>
  </div>
</template>

<script>
import ProfileSectionHeader from "../ProfileSectionHeader.vue"
import ProfileSubSectionHeader from "../ProfileSubSectionHeader.vue"
import options from "@/utils/options"
import { Carousel, Slide, Navigation } from "vue3-carousel"
import "vue3-carousel/dist/carousel.css"
import OperationalDetails from "@/components/Profile/Company/OperationalDetails"

export default {
  name: "company-profile-overview",
  components: {
    ProfileSectionHeader,
    ProfileSubSectionHeader,
    Carousel,
    Slide,
    Navigation,
    OperationalDetails,
  },
  data() {
    return {
      trueFalse: options.trueFalse,
      yesNo: options.yesNo,
      workRadiusOptions: options.workRadiusOptions,
      numberOfEmployeesOptions: options.numberOfEmployeesOptions,
      licensed: this.profile.provider
        ? this.profile.provider.licensed
        : this.profile.vendor
        ? this.profile.vendor.licensedForSpecificProducts
        : null,
      showcasePhotos: this.profile.showcasePhotos ?? [],
      windowWidth: window.innerWidth,
    }
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    jobseekerCompanyView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    itemsToShow() {
      const w = this.windowWidth
      if (w < 576) return 1
      if (w < 950) return 2
      if (w < 1280) return 3
      if (w < 1550) return 4
      if (w < 1768) return 5
      return 6
    },
    showNavigation() {
      return this.showcasePhotos.length > this.itemsToShow
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize)
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    handleEditClick() {
      this.$emit("handle-edit-click")
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
  watch: {
    profile: {
      deep: true,
      handler(newVal) {
        this.showcasePhotos = newVal.showcasePhotos
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.company-desc {
  text-align: justify;
  color: #3a4252;
}

.company-profile-photos {
  :deep(.left-aligned-carousel .carousel__track) {
    transform: unset !important;
    justify-content: flex-start;
  }

  .carousel__slide {
    padding: 0 5px;

    img {
      max-width: 100%;
      height: auto;
      border-radius: 8px !important;
      border: 1px solid #b0b9c9 !important;
    }
  }
}

@media (max-width: 768px) {
  .company-profile-photos {
    margin: 0 auto;
    padding: 0 10px;
  }
}
</style>
